import { motion } from 'framer-motion';
import { techNews } from '../data';
import TechNewsCard from '../components/TechNewsCard';
import { Newspaper, Brain, Cpu, Car } from 'lucide-react';

const categoryIcons: Record<string, React.ReactNode> = {
  deepLearning: <Brain className="text-blue-400" size={24} />,
  llm: <Cpu className="text-purple-400" size={24} />,
  autonomousDriving: <Car className="text-green-400" size={24} />,
};

const categoryGradients: Record<string, string> = {
  deepLearning: 'from-blue-500/20 to-cyan-500/20',
  llm: 'from-purple-500/20 to-pink-500/20',
  autonomousDriving: 'from-green-500/20 to-emerald-500/20',
};

export default function TechNews() {
  return (
    <div className="min-h-screen pt-24 pb-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <div className="flex items-center justify-center space-x-3 mb-4">
            <Newspaper className="text-purple-400" size={32} />
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
            科技资讯
          </h1>
          <p className="text-xl text-pink-200/70 max-w-2xl mx-auto">
            每日精选 GitHub 热门项目与技术动态
          </p>
        </motion.div>

        {/* News Categories */}
        <div className="space-y-12">
          {techNews.map((category, categoryIndex) => (
            <motion.section
              key={category.key}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: categoryIndex * 0.1 }}
              viewport={{ once: true }}
            >
              {/* Category Header */}
              <div
                className={`flex items-center space-x-3 mb-6 p-4 rounded-xl bg-gradient-to-r ${categoryGradients[category.key]} border border-pink-500/20`}
              >
                {categoryIcons[category.key]}
                <h2 className="text-2xl font-bold text-white">{category.name}</h2>
                <span className="text-sm text-pink-300/70">
                  ({category.items.length} 个项目)
                </span>
              </div>

              {/* News Items */}
              <div className="space-y-4">
                {category.items.map((item, index) => (
                  <TechNewsCard key={item.title} item={item} index={index} />
                ))}
              </div>
            </motion.section>
          ))}
        </div>

        {/* Update Time */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ delay: 0.5 }}
          viewport={{ once: true }}
          className="text-center mt-16 text-pink-300/50 text-sm"
        >
          数据更新时间：{new Date().toLocaleString('zh-CN')}
        </motion.div>
      </div>
    </div>
  );
}
